var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-container"},[_c('article',{staticClass:"page",domProps:{"innerHTML":_vm._s(_vm.displayArticle.html)},on:{"click":_vm.onClick}}),(_vm.error)?_c('ErrorAlert',{attrs:{"error":_vm.error}}):_vm._e(),(_vm.loading)?_c('Spinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }